import { Checkbox, Grid, makeStyles, Tooltip, Typography, useTheme } from '@material-ui/core';
import { CardClienteRespostaPropagandaProps } from './card-cliente-resposta-propaganda-props';
import { DefaultCard } from '../components/default-card';
import { memo, useCallback } from 'react';
import { EnumSituacaoPessoa } from 'model/enums/enum-situacao-pessoa';
import { useThemeQueries } from 'views/theme';
import { formatarCPFCNPJ } from 'utils/cpfcnpj-format';

const useStyles = makeStyles((theme) => (
  {
    cardRightButton: {
      width: "50px",
      borderLeftWidth: 1,
      borderLeftStyle: "solid",
      borderLeftColor: theme.palette.divider,
      margin: '0px 0px 0px 10px',
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
      "& svg": {
        margin: 0,
        width: "22px",
        height: "22px",
        fill: theme.palette.primary.main,
      },
    },
    container: {
      padding: theme.spacing(2),
      "& .MuiTypography-body1": {
        fontSize: 12
      },

    }
  }
))

export const CardClienteRespostaPropaganda = memo(({
  model,
  onClick,
  onCheck,
  selected,
}: CardClienteRespostaPropagandaProps) => {
  const { palette } = useTheme()
  const { isMobile } = useThemeQueries()

  const classes = useStyles()

  const statusColor = useCallback(() => {
    switch (model.status) {
      case 0:
        return palette.success.main
      case 1:
        return palette.error.main
      case 2:
        return palette.warning.main
    }
  }, [model.status, palette.error.main, palette.success.main, palette.warning.main])

  return (
    <>
      <DefaultCard
        isSelected={selected}
        onClick={() => onClick(model)}
      >
        <Tooltip title={EnumSituacaoPessoa[model.status]} placement='right'>
          <div style={{
            backgroundColor: statusColor(),
            width: '5px',
            borderRadius: '5px',
            alignSelf: 'stretch',
            margin: '7px'
          }} />
        </Tooltip>
        <Grid container alignItems="center" className={classes.container}>
          {/* Coluna para as informações do Cliente */}
          <Grid item xs>
            <Typography color="textSecondary" variant="caption">
              {formatarCPFCNPJ(model.cpfCnpj)}
            </Typography>
            <Typography color="textPrimary" variant="body1">
              <b>{model.nomeComercial}</b>
            </Typography>
          </Grid>
          <Grid item xs='auto'>
            <Checkbox
              checked={selected}
              onChange={() => onCheck(model)}
              color="primary"
              inputProps={{ 'aria-label': 'select client' }}
              style={{ padding: isMobile ? 0 : 8 }}
            />
          </Grid>
        </Grid>
      </DefaultCard>
    </>
  );
});
